import { Mesh } from "@babylonjs/core";
import { GLTF2 } from "@babylonjs/loaders";

export class VariantsHandler
{
    private _defaultVariant:number;
    private _mesh:Mesh;
    public Variants:string[] = new Array();
    constructor(mesh:Mesh)
    {
        this._mesh=mesh;
        this.Variants = GLTF2.KHR_materials_variants.GetAvailableVariants(this._mesh);
    }
    get DefaultVariant():number{return this._defaultVariant}
    set DefaultVariant(value:number)
    {
        this._defaultVariant = value;
        var variants = GLTF2.KHR_materials_variants.GetAvailableVariants(this._mesh);
        if(variants.length > 0)
            GLTF2.KHR_materials_variants.SelectVariant(this._mesh,variants[value]);
    }
}